import React, { useRef } from 'react';
import Papa from 'papaparse';
import { Box } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const CsvUploader = ({ onUpload }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (file) => {
    if (file.type !== 'text/csv') {
      alert('Please upload a .csv file.');
      // Reset the file input value
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      return;
    }

    Papa.parse(file, {
      complete: (result) => {
        onUpload(result.data);
        // Reset the file input value
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      },
      header: true,
    });
  };

  return (
    <Box onClick={() => fileInputRef.current.click()} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
      <CloudUploadIcon />
      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        onChange={(e) => handleFileChange(e.target.files[0])}
        style={{ display: 'none' }}
      />
    </Box>
  );
};

export default CsvUploader;